import { memo } from 'react'
import styled from 'styled-components'
import { clickable, grid } from '../../styles'
import { GridProps } from '../../styles/types'
import { filterConfig } from '../../styles/utils/transformProps'

const Grid = styled.div.withConfig(filterConfig).attrs((props: GridProps) => ({
    ...(props.testID ? { 'data-testid': props.testID } : undefined),
}))`
    ${grid}
    ${clickable}
    ${(): string => 'box-sizing: border-box;'}
`

export default memo(Grid)
